export default __webpack_public_path__ + "static/media/mostra-2.f7a8b5df.png";